import styled, { css, SimpleInterpolation } from 'styled-components';
import { up } from 'styled-breakpoints';

interface FullScreenButtonContainerStyleProps {
  isSmallPhone: boolean;
}

export const FullScreenButtonContainer = styled.div<FullScreenButtonContainerStyleProps>`
  button {
    font-size: ${({ theme: { fontSizes } }): string => fontSizes.f3};
    color: #595959;
    text-transform: none;
    border-radius: 100%;
    position: absolute;
    top: 0;
    right: 0;
    max-height: 2.25rem;

    ${up('small-phone')} {
      position: relative;
    }

    ${up('phone')} {
      border-radius: 5rem;
      position: static;
    }

    ${({ isSmallPhone }): SimpleInterpolation =>
      isSmallPhone &&
      css`
        width: 2.25rem;
        height: 2.25rem;
        min-width: auto;
        padding: 0;

        span {
          padding-right: 0;
        }
      `}
  }
`;

export const StyledIcon = css`
  fill: #595959;
  max-width: 1rem;
  margin-bottom: 0.2rem;
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f6};
  width: 1rem;
  height: 1rem;
`;
